<template>
  <div id="changePassword">
    <el-row
      type="flex"
      justify="center"
    >
      <el-col
        :md="20"
        :lg="18"
        :xl="16"
      >
        <el-form
          ref="changePasswordForm"
          :model="rigisterData"
          label-width="80px"
          :rules="rigisterRules"
        >
          <el-form-item label="帳號">
            <span>{{ rigisterData.account }}</span>
          </el-form-item>
          <!-- 解決 Chrome 自動帶入密碼的問題 -->
          <el-form-item class="fakePassword">
            <el-input
              v-model="rigisterData.fakePassword"
              type="password"
            />
          </el-form-item>
          <el-form-item
            label="姓名"
            prop="name"
          >
            <el-input
              v-model="rigisterData.name"
              placeholder="請輸入姓名"
              maxlength="20"
              @input="filterValidValue('name')"
            />
          </el-form-item>
          <el-form-item
            label="密碼"
            prop="password"
          >
            <el-input
              v-model="rigisterData.password"
              type="password"
              maxlength="6"
              placeholder="請再次輸入密碼驗證身分"
              show-password
              @input="filterValidValue('password')"
            />
          </el-form-item>
          <el-row
            type="flex"
            justify="center"
          >
            <el-button
              round
              @click="$toMainPage()"
            >
              取消
            </el-button>
            <el-button
              type="primary"
              round
              @click="sendRigistration()"
            >
              確定
            </el-button>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data () {
    const checkForm = (rule, value, callback) => {
      const passwordRegex = /^\d{6}$/
      const nameRegex = /^[\u4e00-\u9fa5a-zA-Z]+$/
      switch (rule.field) {
        case 'name':
          if (!value) {
            return callback(new Error('姓名不可為空'))
          } else if (!nameRegex.test(value)) {
            return callback(new Error('姓名格式錯誤，限輸入中英文'))
          } else {
            callback()
          }
          break
        case 'password':
          if (!value) {
            return callback(new Error('密碼不可為空'))
          } else if (!passwordRegex.test(value)) {
            return callback(new Error('密碼格式錯誤，請輸入6位數字'))
          } else {
            callback()
          }
          break
        default:
          callback()
          break
      }
    }
    const checkFormChange = (rule, value, callback) => {
      const passwordRegex = /^\d{6}$/
      if (this.haveSendedRigister) {
        switch (rule.field) {
          case 'password':
            if (!value) {
              return callback(new Error('密碼不可為空'))
            } else if (value.length === 6 && !passwordRegex.test(value)) {
              return callback(new Error('密碼格式錯誤，請輸入6位數字'))
            } else {
              callback()
            }
            break
          default:
            callback()
            break
        }
      }
    }
    return {
      rigisterData: {
        account: JSON.parse(localStorage.getItem('loginUserInfo')).Account.replace('auth_', '') || '',
        name: JSON.parse(localStorage.getItem('loginUserInfo')).AdminName || '',
        fakePassword: '',
        password: ''
      },
      rigisterRules: {
        name: [
          { validator: checkForm, trigger: 'blur' },
          { validator: checkForm, trigger: 'change' }
        ],
        password: [
          { validator: checkForm, trigger: 'blur' },
          { validator: checkFormChange, trigger: 'change' }
        ]
      },
      haveSendedRigister: false,
      isSendingRigistration: false
    }
  },
  mounted () {
    setTimeout(() => {
      // eslint-disable-next-line eqeqeq
      if (document.getElementsByClassName('v-modal').length == 0) { // 解決登入過期時 alert 重複顯示的問題
        if (!JSON.parse(localStorage.getItem('loginStatus')) || !this.$getCookie('comLoginToken')) {
          this.$alert('登入過期或驗證失敗，請重新登入', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            this.$logoutCommunity()
          })
        }
        if (!JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount) {
          this.$alert('沒有訪問權限', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            this.$router.back()
          })
          return false
        }
      }
    }, 500)
  },
  methods: {
    sendRigistration () {
      const vm = this
      vm.haveSendedRigister = true
      vm.$refs.changePasswordForm.validate((valid) => {
        if (valid && !vm.isSendingRigistration) {
          vm.isSendingRigistration = true
          const params = {
            Name: vm.rigisterData.name,
            password: vm.rigisterData.password
          }
          apiManagement.PutInfo(params).then(res => {
            // 前端更新用戶姓名
            const loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo'))
            loginUserInfo.AdminName = vm.rigisterData.name
            localStorage.setItem('loginUserInfo', JSON.stringify(loginUserInfo))
            vm.$alert('提醒您管理版APP將同步更新變更資料', '完成姓名變更', {
              confirmButtonText: '確認',
              type: 'success',
              showClose: false,
              roundButton: true,
              closeOnClickModal: false,
              callback: () => {
                vm.refreshCookie()
              }
            })
          }).catch(err => {
            vm.isSendingRigistration = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    filterValidValue (item) {
      const vm = this
      switch (item) {
        case 'name':
          vm.rigisterData.name = vm.rigisterData.name.replace(/[^\u4e00-\u9fa5a-zA-Z]/g, '')
          break
        case 'password':
          vm.rigisterData.password = vm.rigisterData.password.replace(/[^0-9]/g, '')
          break
      }
    },
    refreshCookie () {
      // eslint-disable-next-line eqeqeq
      const url = process.env.NODE_ENV == 'development' ? '/localmvc/Login/RefreshCookie' : `${process.env.VUE_APP_MVC_URL}/Login/RefreshCookie`
      axios(url, {
        method: 'POST'
      }).then((res) => {
        console.log(res)
        this.$toMainPage()
      }).catch((err) => {
        this.$alert(err.response.data.ErrorMessage.Description, '警告', {
          confirmButtonText: '確認',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          if (err.response.status === 401) { router.push({ name: 'LoginMain' }) }
        })
      })
    }
  }
}
</script>

<style lang="sass" scoped>
#changePassword
  padding-top: 40px
  .el-form-item
    text-align: left
    &.fakePassword
      position: absolute
      right: 9999px
</style>
